import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Uncaught render error:", error);
    console.error("[ErrorBoundary] Component stack:", info?.componentStack);
    this.setState({ error });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            background: "#0f172a",
            color: "#e2e8f0",
            fontFamily: "sans-serif",
          }}
        >
          <div style={{ maxWidth: 720 }}>
            <h1 style={{ marginTop: 0 }}>La aplicacion se cayo al renderizar</h1>
            <p style={{ lineHeight: 1.6 }}>
              Mira la consola del navegador para ver el error exacto y el
              componente que lo disparo.
            </p>
            {this.state.error ? (
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  background: "rgba(15, 23, 42, 0.8)",
                  border: "1px solid rgba(148, 163, 184, 0.25)",
                  padding: "16px",
                  borderRadius: "12px",
                  overflowX: "auto",
                }}
              >
                {String(
                  this.state.error?.stack ||
                    this.state.error?.message ||
                    this.state.error
                )}
              </pre>
            ) : null}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
